export const holder = {
    display:             'grid',
    position:            'relative',
    gridTemplateColumns: '1fr min-content',
    gridTemplateRows:    '1fr min-content',
} as const;
export const wrapper = {
    gridColumn: 1,
    gridRow:    1,
} as const;
export const trackVertical = {
    display:    'block',
    position:   'relative',
    width:      8,
    gridColumn: 2,
    gridRow:    1,
} as const;
export const trackHorizontal = {
    display:    'block',
    position:   'relative',
    height:     8,
    gridColumn: 1,
    gridRow:    2,
} as const;
export const thumbVertical = {
    display:    'block',
    position:   'relative',
    width:      '100%',
    height:     0,
    cursor:     'pointer',
} as const;
export const thumbHorizontal = {
    display:    'block',
    position:   'relative',
    height:     '100%',
    width:      0,
    cursor:     'pointer',
} as const;
export const content = {
    position: 'absolute',
    top:      0,
    bottom:   0,
    left:     0,
    right:    0,
    overflow: 'scroll',
} as const;

export const holderGridless = {
    display:  'block',
    position: 'relative',
} as const;
export const wrapperGridless = {
    display:   'block',
    minHeight: '100%',
} as const;
export const trackVerticalGridless = {
    background: 'rgba(0,0,0,.1)',
    position:   'absolute',
    width:      8,
    height:     '100%',
    right:      0,
    top:        0,
} as const;
export const trackHorizontalGridless = {
    background: 'rgba(0,0,0,.1)',
    position:   'absolute',
    height:     8,
    width:      '100%',
    left:       0,
    bottom:     0,
} as const;
